import React from "react";
import { useSelector } from "react-redux";
import { Dropdown, Icon } from "semantic-ui-react";
import { getLocale } from "../../../../utils/helperFunctions";
import useTheme from "../../../../hooks/useTheme";
import { AppPrimaryButton, PrimaryChip } from "../../../UI/CustomButtons";
import { AppColumn, AppRow, Wrap } from "../../../UI/Layouts";
import { SizedBox } from "../../../UI/Sizes";
import AppText from "../../../UI/Texts/AppTexts";
import UserActions from "../../../../utils/Constants/UserActions";
import "../../../../App.css";
import { t } from "i18next";
import { useResponsive } from "../../../UI/ResponsiveContext";

const WorkroleSelectionSection = ({
  formData,
  updateFormData,
  onNext,
  onBack,
}) => {
  const { isMobile } = useResponsive()
  const theme = useTheme();

  const core = useSelector((state) => state.core);
  const coreConstants = Object.freeze(core.constants);

  const professionOptions = (coreConstants.workroles ?? []).map((role) => {
    const text = role.text[getLocale()] ?? role.text["sv"];

    const hasText = text.length > 0

    return {
      key: role.id,
      text: hasText ? text : role.id,
      value: role.id,
      suggested: role.suggested,
    }
  });


  const suggestedRoles = professionOptions.filter((role) => role.suggested && !formData.professions.includes(role.key));

  const handleSelection = (e, { value }) => {
    if (!formData.professions.includes(value)) {
      updateFormData("professions", [...formData.professions, value]);
    }
  };

  const handleRemoveProfession = (profession) => {
    updateFormData(
      "professions",
      formData.professions.filter((p) => p !== profession)
    );
  };

  return (
    <AppColumn style={{

    }}>
      <AppRow mainAxisAlignment={'space-between'} crossAxisAlignment={'center'}>

        <AppText.HeadingBig className={'text-headline'} fontWeight={600}>
          {t('registration.select_profession.title')}
        </AppText.HeadingBig >
        <AppPrimaryButton
          userActionKey={UserActions.workplace_role_selecteds}
          size={'large'}
          onClick={onNext}
          style={{
            borderRadius: theme.radius.small,
          }}>
          {t('next')}
        </AppPrimaryButton>
      </AppRow>

      <SizedBox height={theme.spacing.contentPadding} />
      <AppRow crossAxisAlignment={'center'}>
        <Icon name="graduation" color={theme.primaryColor} style={{
          color: theme.primaryColor,
        }} />
        <AppText.Footnote>
          {` ${t('registration.select_profession.description')}`}
        </AppText.Footnote>
      </AppRow>
      <SizedBox height={theme.spacing.elementPadding} />
      <Dropdown
        placeholder={t('registration.select_profession.dropdown.placeholder')}
        fluid
        selection
        search
        options={professionOptions}
        onChange={handleSelection}
        style={{
          padding: theme.spacing.elementPadding,
          marginBottom: theme.spacing.contentElementPadding,
        }}
        className="custom-height-dropdown"
      />

      {suggestedRoles.length > 0 && <AppColumn>
        <AppText.Caption>{t('registration.select_profession.suggested_roles')}</AppText.Caption>
        <SizedBox height={theme.spacing.elementPadding} />
        <Wrap>
          {suggestedRoles.map((role, index) => {
            return (
              <PrimaryChip
                key={index}
                onClick={() => handleSelection(null, { value: role.key })}
                secondary
                small={isMobile}
                text={role.text}
              />
            );
          })}
        </Wrap>
        <SizedBox height={theme.spacing.contentElementPadding} />
      </AppColumn>}

      {formData.professions.length > 0 && (<AppColumn>
        <AppText.Caption>{t('registration.selected_profession.title')}</AppText.Caption>
        <SizedBox height={theme.spacing.elementPadding} />
        <Wrap>
          {formData.professions.map((profession, index) => {
            const roleText = professionOptions.find((e) => e.key === profession).text;
            return (
              <PrimaryChip
                key={index}
                text={roleText}
                small={isMobile}
                onRemove={() => handleRemoveProfession(profession)} />
            );
          })}
        </Wrap>
      </AppColumn>)}



    </AppColumn>
  );
};

export default WorkroleSelectionSection;